














import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { ExternalImageItem } from "../../../../../../domain/externalImage";
import { IImageDragParameter } from "../../../../../dragging";
import Moment from "moment";

@Component({
  components: {
  }
})
export default class ExternalImageThumbnail extends Mixins() {
  data(): any {
    return {
      imageWidthText: null,
      imageHeightText: null,
    };
  }
  imageWidthText: string;
  imageHeightText: string;
  
  @Prop()
  item: ExternalImageItem;

  @Prop()
  isFocused: boolean;
  
  get imageSource(): string {
    return this.item.source.thumbnailSource;
  }

  adjustImageSize(): void {
    const image = this.$refs.image as HTMLImageElement;
    if (!image) { return; }
    this.imageWidthText = (image.naturalWidth >= image.naturalHeight) ? "100%" : null;
    this.imageHeightText = (image.naturalWidth <= image.naturalHeight) ? "100%" : null;
  }

  get rootStyle(): any {
    return {
      outline: this.isFocused ? "2px solid rgba(255, 0, 0, 0.5)" : "none",
    };
  }

  onDragStart(event: DragEvent): void {
    const data: IImageDragParameter = {
      isExternalImage: true,
      externalImageDragParameter: {
        patientId: this.item.patientId,
        externalImageId: this.item.id,
        imageDateTime: this.item.imageDateTime,
      }
    };
    const text = JSON.stringify(data);
    // 第一引数(format)が"text"でないとIEでエラーになる。
    event.dataTransfer.setData("text", text);
  }

  onThumbnailSelected(event: PointerEvent): void {
    this.selected(this.item);
  }

  @Emit()
  selected(src: ExternalImageItem): void {}

  get title(): string {
    return this.item.imageDateTime
      ? Moment(this.item.imageDateTime).format("YYYY/MM/DD")
      : null;
  }
}
